const AyudateSesion = {
  verificarSesion() {
    let sesion = localStorage.getItem("id");
    if (sesion) return true;
    return false;
  },

  obtenerDatosSesion() {
    const id = localStorage.getItem("id");
    const usuario = localStorage.getItem("usuario");
    const nombre = localStorage.getItem("nombre");
    const rol = localStorage.getItem("rol");
    const telefono = localStorage.getItem("telefono");
    const puntos = localStorage.getItem("puntos");

    return {
      id: id,
      usuario: usuario,
      nombre: nombre,
      rol: rol,
      telefono: telefono,
      puntos: puntos,
    };
  },

  establecerSesion(usuario) {
    localStorage.setItem("id", usuario.id);
    localStorage.setItem("usuario", usuario.usuario || usuario.telefono || "");
    localStorage.setItem("telefono", usuario.telefono || usuario.usuario || "");
    localStorage.setItem("nombre", usuario.nombre || "");
    localStorage.setItem("rol", usuario.rol || "cliente");
    localStorage.setItem("puntos", usuario.puntos || 0);
    localStorage.setItem("direccion", usuario.direccion || "");
    localStorage.setItem("correo", usuario.correo || "");
    localStorage.setItem("nit", usuario.nit || "");
    localStorage.setItem("primeraCompra", usuario.primeraCompra || "si");
    localStorage.setItem(
      "requiereMinimoInicial",
      usuario.requiereMinimoInicial ? "true" : "false"
    );
    localStorage.setItem("comprasPrevias", usuario.comprasPrevias || 0);

  },

  obtenerDatosNegocio() {
    return {
      nombre: localStorage.getItem("nombreNegocio"),
      telefono: localStorage.getItem("telefonoNegocio"),
      logo: localStorage.getItem("logoNegocio"),
      nit: localStorage.getItem("nit"),
      frase: localStorage.getItem("frase"),
      direccion: localStorage.getItem("direccion"),
      logofactura: localStorage.getItem("logofactura"),
    };
  },

  cerrarSesion() {
    localStorage.removeItem("id");
    localStorage.removeItem("usuario");
    localStorage.removeItem("telefono");
    localStorage.removeItem("nombre");
    localStorage.removeItem("rol");
    localStorage.removeItem("puntos");
    localStorage.removeItem("direccion");
    localStorage.removeItem("correo");
    localStorage.removeItem("nit");
    localStorage.removeItem("primeraCompra");
    localStorage.removeItem("requiereMinimoInicial");
    localStorage.removeItem("comprasPrevias");
    location.reload();
  },
};

export default AyudateSesion;
